





































import { Component, Prop, Vue } from 'vue-property-decorator';

import { ReportDirectory } from '@/models/report.model';
import { ReportStore } from '@/store/report';

import ReportPageListItemFetching from './ReportPageListItemFetching.vue';


@Component({
  components: {
    ReportPageListItemFetching,
  },
})
export default class ReportPageListItemFolder extends Vue {
  @ReportStore.Bind.Action fetchSubdirectory!: ReportStore.Action<'fetchSubdirectory'>;

  @Prop() name!: string;
  @Prop() path!: string;

  isFetching = false;
  subdirectory: ReportDirectory | null = null;

  async toggleContent() {
    if (this.subdirectory) {
      this.subdirectory = null;
    }
    else {
      this.isFetching = true;
      this.subdirectory = await this.fetchSubdirectory(`${this.path}${this.name}`);
      this.isFetching = false;
    }
  }
}
